// Noodl SDK - webpack handles this require properly
const Noodl = require('@noodl/noodl-sdk');

// Import shared theme styles (fonts and icons loaded by Noodl project)
import '@shared/theme/variables.css';

// Force CSS to be loaded with the module JS bundle
// This ensures styles are available even after page refresh/navigation
if (typeof document !== 'undefined') {
  const existingStylesheet = document.querySelector('link[href="/noodl_modules/prodikt-react-ui/style.css"]');
  if (!existingStylesheet) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = '/noodl_modules/prodikt-react-ui/style.css';
    document.head.appendChild(link);
  }
}

// Import component nodes
import { CustomButtonNode } from '@nodes/custom-button/CustomButtonNode';
import { CustomCheckboxNode } from '@nodes/custom-checkbox/CustomCheckboxNode';
import { CustomSelectNode } from '@nodes/custom-select/CustomSelectNode';
import { CustomSelectAltNode } from '@nodes/custom-select-alt/CustomSelectAltNode';
import { CustomTextAreaNode } from '@nodes/custom-text-area/CustomTextAreaNode';
import { CustomTextInputNode } from '@nodes/custom-text-input/CustomTextInputNode';
import { CustomToggleNode } from '@nodes/custom-toggle/CustomToggleNode';

// Import view nodes
import { ProjectCardNode } from '@nodes/project-card/ProjectCardNode';
import { ProjectListNode } from '@nodes/project-list/ProjectListNode';
import { ProjectViewNode } from '@nodes/project-view/ProjectViewNode';

// Import modal nodes
import { ProductEpdDataModalNode } from '@nodes/product-epd-data-modal/ProductEpdDataModalNode';

// Import logic nodes
import { TelemetryNode } from '@nodes/telemetry/TelemetryNode';

/**
 * Register the Prodikt React UI module with Noodl
 */
Noodl.defineModule({
  reactNodes: [
    // Component nodes
    CustomButtonNode,
    CustomCheckboxNode,
    CustomSelectNode,
    CustomSelectAltNode,
    CustomTextAreaNode,
    CustomTextInputNode,
    CustomToggleNode,
    // View nodes
    ProjectCardNode,
    ProjectListNode,
    ProjectViewNode,
    // Modal nodes
    ProductEpdDataModalNode,
  ],
  nodes: [
    TelemetryNode,
  ],
  setup() {
    console.log('Prodikt React UI module loaded');
  },
});
